import { AppButton } from 'components';
import {
  AppModal,
  AppModalBody,
  AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import { useEffect, useState } from 'react';
// import { RiDragMoveFill } from 'react-icons/ri';
import { ReactSortable } from 'react-sortablejs';
import { BlocksImageTypes } from './Notes/Blocks/AppBlocks';

function ReorderBlocks({ closeModal, open, data = {} }) {
  const { blocks, type, handleSubmission } = data || {};

  const [activeBlocks, setActiveBlocks] = useState([]);

  useEffect(() => {
    setActiveBlocks(blocks?.map((x) => ({ ...x, id: x._id })) ?? []);
    return () => {};
  }, [blocks]);

  return (
    <AppModal open={open} closeModal={closeModal}>
      <AppModalHeader>Reorder blocks ({type})</AppModalHeader>
      <AppModalBody>
        <div className="__topicReorder drop">
          <ReactSortable
            list={activeBlocks}
            setList={(newBlocks) => {
              setActiveBlocks(newBlocks?.map?.((n, i) => ({ ...n, sortPosition: i })));
            }}
            handle=".__blockSection"
            className="__topic_reorder_body drop_container"
          >
            {activeBlocks.map((b, i) => {
              const __blockType = setType(b.currentBlock);
              return (
                <div className="drop_card __blockSection" key={b._id} style={{ cursor: 'grab' }}>
                  <div className="drop_data">
                    <BlocksImageTypes
                      type={b.currentBlock}
                      imageProps={{
                        className: 'drop_img mx-4',
                        alt: 'reorder ' + __blockType + ' block',
                      }}
                    />

                    <div>
                      <h1 className="drop_name">{__blockType}</h1>
                      {b.caption && <span className="drop_profession">{b.caption}</span>}
                    </div>
                    {/* <span className="ml-auto">
                      <RiDragMoveFill />
                    </span> */}
                  </div>
                </div>
              );
            })}
          </ReactSortable>
        </div>

        <div className="app-l-modal-btn-block">
          <AppButton
            variantClass="btn-plane p--tint mx-4"
            onClick={() => {
              handleSubmission({ blocks: activeBlocks, reOrderingQuotient: true });
            }}
          >
            Save
          </AppButton>
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={closeModal}>
            Close
          </AppButton>
        </div>
      </AppModalBody>
      <AppModalFooter></AppModalFooter>
    </AppModal>
  );
}

ReorderBlocks.defaultProps = {
  closeModal: () => {},
  handleReorder: () => {},
};

function setType(type) {
  switch (true) {
    case type === 'text':
      return 'Text';
    case type === 'image':
      return 'Image';
    case type === 'equation':
      return 'Equation';
    case type === 'problem':
      return 'Problem';
    case type === 'tip':
      return 'Tip';
    case type === 'box':
      return 'Box';
    case type === 'video':
      return 'Video';
    case type === 'audio':
      return 'Audio';
    case type === 'file':
      return 'File';
    default:
      return '';
  }
}

export default ReorderBlocks;
